import { Component, EventEmitter, Input, OnInit, Output, ViewChild, TemplateRef } from '@angular/core';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';
import * as ImageActions from '@app/modules/image/store/actions/image.actions';
import { Store } from '@ngrx/store';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LabelLogoService } from '@app/services/label-logo/label-logo.service';

@Component({
    selector: 'app-image-cropper',
    templateUrl: './image-cropper.component.html',
    styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit {

    @Input() type: string;
    @Output() saved = new EventEmitter<void>();

    public imageChangedEvent: any = '';
    public croppedImage: any = '';
    public canvasRotation = 0;
    public aspectRatio = 1 / 1;
    public resizeToWidth: number = 290;
    public rotation = 0;
    public scale = 1;
    public maintainAspectRatio: boolean = true;
    public showCropper = false;
    public containWithinAspectRatio = true;
    public transform: ImageTransform = {};
    public bgColor: string = '#fff';
    public isSelecting: boolean = false;

    @ViewChild('cropperDialog') cropperDialog: TemplateRef<any>;
    private dialogRef: MatDialogRef<any> | null = null;
    private fileInput: HTMLInputElement | null = null;

    constructor(
        private _imageUpload: ImageUploadService,
        private store$: Store,
        private dialog: MatDialog,
        private _labelLogo: LabelLogoService
    ) {
    }

    ngOnInit(): void {
        if (this.type === 'labelLogo') {
            // Label logos are wide, forcing them into a square adds the blank
            // margins that make the printed logo tiny
            this.maintainAspectRatio = false;
            this.containWithinAspectRatio = false;
            this.resizeToWidth = 600;
        }
    }

    onOpenModal() {

    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
        this.isSelecting = true;
        this.fileInput = event?.target || null;
        this._imageUpload.onSetLogoUpload();

        // Open the cropper in a dialog so it always fits the screen.
        this.dialogRef = this.dialog.open(this.cropperDialog, {
            panelClass: 'image-cropper-dialog',
            width: '560px',
            maxWidth: '95vw',
            autoFocus: false,
        });
        this.dialogRef.afterClosed().subscribe(() => {
            this.isSelecting = false;
            this.imageChangedEvent = '';
            // Reset the input so picking the same file again re-opens the cropper.
            if (this.fileInput) { this.fileInput.value = ''; }
        });
    }

    cancelCrop() {
        this.dialogRef?.close();
    }

    imageCropped(event: ImageCroppedEvent) {

        if (event.base64) {
            this.croppedImage = event.base64;
          } else if (event.blob) {
            const reader = new FileReader();
            reader.onload = () => {
              this.croppedImage = reader.result as string;
            };
            reader.readAsDataURL(event.blob);
          } else {
            console.error('Cropping failed: no data received.');
          }

        this.croppedImage = event.base64;
        switch (this.croppedImage) {
            case 'siteLogo':
                this._imageUpload.onSetCroppedImage(this.croppedImage);
                break;
            // case 'profileLogo':
            //     this._imageUpload.onStoreProfileImage(this.croppedImage);
            // break;
            default:
                return 'No cropper chosen';
        }
    }

    imageLoaded() {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }


    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH
        };
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV
        };
    }

    resetImage() {
        switch (this.type) {
            case 'siteLogo':
                this._imageUpload.onResetLogo();
                this.croppedImage = "";
                break;
            case 'reportLogo':
                this._imageUpload.onResetReportLogo();
                break;
            case 'labelLogo':
                this._labelLogo.resetLabelLogo().subscribe(() => this.saved.emit());
                this.croppedImage = "";
                break;
            case 'profileLogo':
                this.store$.dispatch(ImageActions.removeProfileImage());
                break;
        }

    }

    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }

    onSubmit() {
        this._imageUpload.onFinishCroppedImage();
        this._imageUpload.onSetFinishUpload()
        this.imageChangedEvent = '';
        this.isSelecting = false;
        this.dialogRef?.close();
        switch (this.type) {
            case 'siteLogo':
                this._imageUpload.onStoreLogo(this.croppedImage);
                break;
            case 'profileLogo':
                this.store$.dispatch(ImageActions.storeProfileImage({ data: this.croppedImage }));
                // this._imageUpload.onPostProfileImage(this.croppedImage);
                break;
            case 'reportLogo':
                this._imageUpload.onStoreReportLogo(this.croppedImage);
                break;
            case 'labelLogo':
                this._labelLogo.storeLabelLogo(this.croppedImage).subscribe(() => this.saved.emit());
                break;
            default:
                return
        }

        this.croppedImage = '';
    }
}